import { canActivateWirelessRoutesGuard } from '@rogers/self-serve-common/deeplink';
import { OVERVIEW_ROUTE } from '@rci/self-serve-fido/app.constant';
import { SigninGuard } from '@rci/self-serve-fido/core/signin/signin.guard';
import { EnsureNoGlobalApiErrorGuard } from '@rci/self-serve-fido/shared/error/ensure-no-global-api-error.guard';
import { AreAccountsLinkedGuard } from '@rci/self-serve-fido/link-account/are-accounts-linked.guard';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { selectAccountGuard } from '@rci/self-serve-fido/shared/account-selector-modal/select-account.guard';

export const commonGuards = [SigninGuard, EnsureNoGlobalApiErrorGuard, AreAccountsLinkedGuard];

export const getWirelessDeeplinkGuard = (routeName: string) => {
  return [
    ...commonGuards,
    () =>
      canActivateWirelessRoutesGuard(
        OVERVIEW_ROUTE,
        OVERVIEW_ROUTE,
        false,
        false,
        `ban-ctn-selector-modal.${routeName}.header`,
        `ban-ctn-selector-modal.${routeName}.sub-header`,
      ),
  ];
};

export const selectActiveNonPrepaidAccountGuard = (
  activateRoute: ActivatedRouteSnapshot,
  routerStateSnapshot: RouterStateSnapshot,
) => selectAccountGuard(activateRoute, routerStateSnapshot, true, true);
